export type SearchParamsType = {
  filter: {
    search: string;
    status: number;
    searchDate: string | null;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
};

export type MasterTableDataType = {
  name: string;
  id: number;
  uomAbbr: string;
  status: number;
  createdById: number;
  clinicId: number;
  createdDate: string;
  code: string;
};

export type MasterDataType = {
  id: number;
  uomAbbr: string;
  clinicId: number;
  code: string;
  createdById: number;
  createdDate: string;
  name: string;
  status: number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  code: string;
  name: string;
  uomAbbr: string;
  status:number
};

export const initialFormData: MasterFormDataType = {
  code: "",
  name: "",
  uomAbbr: "",
  status:1
};
